import './PanelMenu.css';
import React from 'react';
import PanelItem from './PanelItem';
var PanelMenu = function PanelMenu(_ref) {
  var rtl = _ref.rtl,
    items = _ref.items;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-menu__items"
  }, !!items.length && items.map(function (item) {
    return /*#__PURE__*/React.createElement(PanelItem, {
      key: item.id,
      item: item
    });
  }))));
};
export default PanelMenu;
var StyledWrapper = function StyledWrapper(_ref2) {
  var rtl = _ref2.rtl,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "ccavwio";
var rtlStyles = "r7jvbkt";
var ltrStyles = "lp3kqp6";